import type { AxiosInstance } from 'axios';

import type { AuthUser } from '../hooks/useAuth';

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  jobTitle?: string | null;
  about?: string | null;
  phone?: string | null;
  linkedinUrl?: string | null;
}

export interface UpdateProfileResponse {
  user: AuthUser;
}

export function createUserService(client: AxiosInstance) {
  return {
    async updateProfile(body: UpdateProfileRequest): Promise<UpdateProfileResponse> {
      const { data } = await client.patch<UpdateProfileResponse>('/auth/me', body);
      return data;
    },
  };
}

export type UserService = ReturnType<typeof createUserService>;
